var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var Single = function (_PureComponent) {
  _inherits(Single, _PureComponent);

  function Single(props) {
    _classCallCheck(this, Single);

    var _this = _possibleConstructorReturn(this, (Single.__proto__ || Object.getPrototypeOf(Single)).call(this, props));

    _this._generateRadioList = function () {
      var _this$props = _this.props,
          name = _this$props.name,
          options = _this$props.options;
      var value = _this.state.value;

      var style = {
        option: {
          width: 'calc(100% / ' + options.length + ')'
        }
      };

      return options.map(function (item, index) {
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
          return React.createElement(
            'div',
            { className: 'tg-radio-option', key: index, style: style.option },
            React.createElement('input', {
              name: name,
              type: 'radio',
              value: item.value,
              id: name + '-' + item.value,
              checked: value == item.value ? 'checked' : '',
              onChange: _this._handleChange
            }),
            React.createElement(
              'label',
              { htmlFor: name + '-' + item.value },
              item.label
            )
          );
        }

        return React.createElement(
          'div',
          { className: 'tg-radio-option', key: index, style: style.option },
          React.createElement('input', {
            name: name,
            type: 'radio',
            value: item,
            id: name + '-' + item,
            checked: value == item ? 'checked' : '',
            onChange: _this._handleChange
          }),
          React.createElement(
            'label',
            { htmlFor: name + '-' + item },
            item
          )
        );
      });
    };

    _this._handleChange = function (e) {
      var onChange = _this.props.onChange;

      var value = e.currentTarget.value;

      _this.setState({
        value: value
      });

      onChange && onChange(e);
    };

    var firstOption = props.options[0];
    _this.state = {
      value: props.value || ((typeof firstOption === 'undefined' ? 'undefined' : _typeof(firstOption)) === 'object' ? firstOption.value : firstOption)
    };
    return _this;
  }

  _createClass(Single, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'tg_input layout-item-full-width' },
        this._generateRadioList()
      );
    }
  }]);

  return Single;
}(PureComponent);

Single.propTypes = {
  /** Name of the element */
  name: PropTypes.string,
  /** Array containing all options */
  options: PropTypes.array
};

Single.defaultProps = {
  name: '',
  options: []
};

export default Single;